import { formatDuration, MINUTES_IN_DAY } from '@/shared/lib/datetime';

import { Chip } from './Chip';
import { NumberInput } from './NumberInput';

interface DurationPickerProps {
  /** Быстрые сроки: у сна — часы, у встречи и задачи — минуты. */
  presets: readonly number[];
  value: number;
  onChange: (durationMin: number) => void;
}

/**
 * Длительность: быстрые сроки одним касанием и поле для любого другого.
 *
 * Один выбор на оценку задачи, длительность встречи и слот режима дня — чтобы
 * срок везде выбирался одинаково и с одними пределами.
 */
export function DurationPicker({ presets, value, onChange }: DurationPickerProps) {
  return (
    <>
      <div className="flex flex-wrap gap-2">
        {presets.map((preset) => (
          <Chip
            key={preset}
            selected={preset === value}
            accent="var(--kairo-brand)"
            onClick={() => onChange(preset)}
          >
            {formatDuration(preset)}
          </Chip>
        ))}
      </div>
      <NumberInput
        aria-label="Длительность в минутах"
        min={5}
        max={MINUTES_IN_DAY}
        step={5}
        suffix="мин"
        value={value}
        onChange={onChange}
        className="mt-2"
      />
    </>
  );
}
